import styled from 'styled-components';

import { SpaceBetweenBlock, VerticalHorizontalCenterColumnBlock } from '../../../styled';
import { Wrapper as CodeWrapper } from './styles';

export const Wrapper = styled(VerticalHorizontalCenterColumnBlock)`
  border-radius: inherit;
`;

export const LabelWrapper = styled(SpaceBetweenBlock)<{ extra: boolean }>`
  width: 100%;
  justify-content: ${(props) => (props.extra ? 'space-between' : 'start')};
`;

export const Label = styled.div`
  ${(props) => props.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
`;

export const CopyWrapper = styled.div`
  position: absolute;
  visibility: hidden;
  opacity: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  top: 0;
  right: 0;
  transition: visibility 0.3s linear 150ms, opacity 150ms;

  ${CodeWrapper}:hover & {
    visibility: visible;
    transition: visibility 0.3s linear 150ms, opacity 150ms;
    opacity: 1;
  }
`;

export const CopyButtonWrapper = styled.div`
  padding-top: 12px;
  padding-right: 12px;
  display: flex;
  gap: 8px;
  justify-content: center;
`;
